import {Map} from 'immutable';
import {DefaultRootState} from 'react-redux';
import {createSelector} from 'reselect';

import {AcceptanceType, DocumentContentType} from 'app/acceptance/types';
import {objectsToFlatArray} from 'app/utils/redux';

export const getRelatedAcceptanceObject = createSelector<
  DefaultRootState,
  AcceptanceType | undefined,
  Map<string, AcceptanceType>,
  {ct: DocumentContentType; objectId}
>(
  (state) => state.acceptance,
  (state, info) => info,
  (acceptance, info): AcceptanceType | undefined => {
    const acceptances = acceptance.getIn([info.ct, info.objectId]);
    if (acceptances == null) {
      return undefined;
    }
    return objectsToFlatArray(acceptances)[0] as AcceptanceType;
  }
);
